import React, { useEffect, useState } from "react";
import {Form, message, Button} from 'antd';
import RichText from "./RichText";
import {
  getArticleContactApi,
  updateArticleContactApi,
} from "../../../api/ManageApi";
import GlobalLoader from "../../../components/GlobalLoading";

const ArticleContact = () => {
  const [article, setArticle] = useState<any>();
  const [form] = Form.useForm();

  useEffect(() => {
    getArticleContactApi().then((res) => {
      if (res.status) {
        setArticle(res?.data)
      }
    })
  }, []);

  useEffect(() => {
    if(!!article) {
      form.resetFields();
      form.setFieldsValue({
        ...article,
      })
    }
  }, [article, form]);

  const handleSubmit = async () => {
    try {
      await form.validateFields();
    } catch (error: any) {
      try {
        form.scrollToField(error?.errorFields[0].name);
      } catch(error) {}
      return;
    }
    let data = form.getFieldsValue();
    GlobalLoader.show();
    updateArticleContactApi({
      content: data?.content,
    }).then((res) => {
      if (res.status) {
        message.success('保存内容成功')
      } else {
        message.error(res?.error || '')
      }
      GlobalLoader.hide();
    })
  };

  return <>
    <Form
      form={form}
      style={{margin: '3em 0'}}
      labelCol={{ span: 5 }}
      wrapperCol={{ span: 18}}>
      {
        ['zh', 'en', 'ja'].map((lang) => (
          <Form.Item key={lang} label={`${lang === 'ja' ? '日' : lang === 'en' ? '英' : '中'}文内容`}>
            <Form.Item
              name={['content', lang, 'content']}>
              {/* @ts-ignore */}
              <RichText />
            </Form.Item>
          </Form.Item>
        ))
      }
      <Form.Item
        wrapperCol={{ span: 18, offset: 5}}
        style={{marginTop: '2em'}}
        rules={[{required: true, message: ''}]}>
          <Button type='primary' style={{width: '100%'}} onClick={handleSubmit}>保存</Button>
      </Form.Item>
    </Form>
  </>;
};

export default ArticleContact;